var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasBlockButton)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.click('block')}}},[_vm._v(_vm._s(_vm.$tf('block')))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }